export default __webpack_public_path__ + "static/media/6f7abe26-e73c-461a-8cd8-fdcad3c9ab4a.c5a15ffc.png";